// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FinancialAid_wrapper__KI1G_","modalContent":"FinancialAid_modalContent__whhw4","content":"FinancialAid_content__28PiK","attention":"FinancialAid_attention__yT7dK"};